import React from "react";

const EgretSidenavHeightContainer = ({ children }) => {
  return <div className="egret-sidenav-container" style={{'height':'1000px'}}>{children}</div>;
};

export default EgretSidenavHeightContainer;
